import { useMemo } from 'react';
import { Form } from 'antd';
import { useGetAllStore } from '@/store/Store';
import { useGetPlanogramsByProduct } from '@/store/Product/useGetPlanogramsByProduct';
import { PlanogramProductCreateFromProduct } from './type';

export const useOverwriteStores = () => {
    const form = Form.useFormInstance();

    const storeIds = Form.useWatch(['stores'], form) as number[];

    const planogram = Form.useWatch(
        ['planogram'],
        form,
    ) as PlanogramProductCreateFromProduct;

    const { data: stores } = useGetAllStore();

    const { data: planograms, isLoading } = useGetPlanogramsByProduct({
        productId: planogram?.product_id,
    });

    const planogramExistsInStores = useMemo(() => {
        if (!stores || !planograms) return [];

        const storeIdsWithPlanogram = planograms.planogram.map(
            (p) => p.store_id,
        );

        return stores
            .map((store) => ({
                ...store,
                hasPlanogram: storeIdsWithPlanogram.includes(store.id),
            }))
            .sort((a, b) => Number(a.hasPlanogram) - Number(b.hasPlanogram));
    }, [planograms, stores]);

    const storesToOverwrite = useMemo(
        () =>
            planogramExistsInStores.filter(
                (store) => store.hasPlanogram && storeIds?.includes(store.id),
            ),
        [planogramExistsInStores, storeIds],
    );

    return {
        storeIds,
        planogram,
        planograms,
        planogramExistsInStores,
        storesToOverwrite,
        isLoading,
    };
};
